import { createDecorator } from "vue-class-component";
import { SYM_ROOT_CONTAINER } from "../di";
/**
 * Injects a reactive state into the decorated property.
 * @param type The store providing the state
 * @param project Optional. A projection function
 */
export function InjectState(type, project) {
    return createDecorator((componentOptions, propertyKey) => {
        const { subscriptions = () => { }, } = componentOptions;
        componentOptions.subscriptions = function () {
            const container = this[SYM_ROOT_CONTAINER];
            const store = container.get(type);
            const observableSource = project ? project(store.value$) : store.value$;
            return {
                [propertyKey]: observableSource,
                ...subscriptions.bind(this)(),
            };
        };
    });
}
//# sourceMappingURL=decorators.js.map